import type { CSSObject } from "type/tss";
import { designTokens } from "theme";

export const styles = () => {
	return {
		root: {
			display: "inline-flex",
			alignItems: "center",
			gap: 4,
			fontSize: 12,
			fontWeight: 400,
			color: designTokens.colors.grayDark,
			// The ids are what someone copies by hand when the clipboard is refused, so they must be
			// selectable even inside a clickable row.
			userSelect: "text",
		},
		copyButton: {
			padding: 2,
			color: designTokens.colors.iconNeutral,
		},
		copyIcon: {
			fontSize: 12,
		},
	} satisfies Record<string, CSSObject>;
};
